export const data = [
  { id: 1, title: "Burger", rutitle: "Burger", main: "-" },
  { id: 2, title: "Burger", rutitle: "Burger", main: "-" },
  { id: 3, title: "Burger", rutitle: "Burger", main: "-" },
  { id: 4, title: "Burger", rutitle: "Burger", main: "-" },
  { id: 5, title: "Burger", rutitle: "Burger", main: "-" },
  { id: 6, title: "Burger", rutitle: "Burger", main: "-" },
];
